import { Cart } from './cart';

export const CART: Cart[] = []